import React, { useState, useEffect } from 'react';
import './WelcomeBanner.css';

const STORAGE_KEY = 'systemcraft_welcome_dismissed';

function WelcomeBanner({ onFirstDraw, selectedQuestion, onStartTour }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Only show if we have a selected question (on design screen)
        if (!selectedQuestion) {
            setIsVisible(false);
            return;
        }

        // Check if user has dismissed the banner today
        const dismissedDate = localStorage.getItem(STORAGE_KEY);
        const today = new Date().toDateString();

        if (dismissedDate !== today) {
            setIsVisible(true);
        }
    }, [selectedQuestion]);

    // Auto-dismiss when user starts drawing
    useEffect(() => {
        if (onFirstDraw && isVisible) {
            handleDismiss();
        }
    }, [onFirstDraw, isVisible]);

    const handleDismiss = () => {
        setIsVisible(false);
        const today = new Date().toDateString();
        localStorage.setItem(STORAGE_KEY, today);
    };

    if (!isVisible) return null;

    return (
        <div className="welcome-banner">
            <div className="welcome-content">
                <span className="welcome-emoji">👋</span>
                <div className="welcome-text">
                    <strong>New here?</strong> Follow these 3 steps:
                    <span className="welcome-steps">
                        <span className="step">①&nbsp;Read&nbsp;requirements</span>
                        <span className="step-separator">→</span>
                        <span className="step">②&nbsp;Draw&nbsp;your&nbsp;design</span>
                        <span className="step-separator">→</span>
                        <span className="step">③&nbsp;Submit</span>
                    </span>
                    {onStartTour && (
                        <button className="tour-button" onClick={onStartTour} title="Start guided tour">
                            Start Tour
                        </button>
                    )}
                </div>
            </div>
            <button className="welcome-close" onClick={handleDismiss} title="Dismiss">
                ✕
            </button>
        </div>
    );
}

export default WelcomeBanner;
